// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toc-wide-variant":"_1NGRGP","bottom":"_1z7oQO","hideDesktop":"_2DBqYD","hideNotDesktop":"_1m1V6m","stickyBox":"_3Aup1P"};